import {createFrontendFeature} from '../../core/model/feature.js';
import {hasFeature} from '../../core/service/env.js';
import {authUser} from '../../userPool/context/auth-user.js';

const name = 'hotornot';

export const feature = createFrontendFeature('hotornot');
feature.hidden = !hasFeature(name);

/**
 * @param {Element} element
 */
export const compile = (element) => {
  if (feature.hidden || !authUser) {
    element.remove();
  }
};
